import React from "react";

function HomeFooter() {
  return <div>HomeFooter</div>;
}

export default React.memo(HomeFooter);
